// check and convert ""object"" to "object"
export function convertExactObjectName(objectName: string) {
  const isObjectNameExact =
    objectName[0] === '"' && objectName[objectName.length - 1] === '"';
  if (isObjectNameExact) return objectName.slice(1, objectName.length - 1);
  return objectName;
}
